function reject(err) {
  const message = err.message || `${err.status}: ${err.statusText}`;
  App.drawMessage({
    message,
    status: 'error',
  });
}

// TODO: is this always the response structure?
function resolve(response) {
  try {
    // support object response, accounting for error status
    if (response.data.status === 'error')
      throw new Error(`${response.data.statusmsg}, status code = ${response.data.statuscode}`);
    if (!response.data.content) throw new Error('No data retrieved'); // TODO: think of better message
    return response.data.content;
  } catch (e) {
    reject(e);
  }
}

function resolveAll(responseList) {
  try {
    let dataList = [],
      errorList = [],
      moreList = [];
    _.forEach(responseList, (resp) => {
      if (resp.data.status === 'error') errorList.push(`${resp.data.statusmsg}. ${resp.data.statuscode}`);
      else dataList.push(resp.data.content[0]);
    });

    if (errorList.length) {
      moreList = errorList.splice(3);
      const extraMsg =
        moreList.length > 0 ? `<br/>+ ${moreList.length} more ${moreList.length > 1 ? 'errors' : 'error'}` : '';
      throw new Error(`${errorList.join('<br/>')}${extraMsg}`);
    }
    return dataList;
  } catch (e) {
    reject(e);
  }
}

export { resolve, resolveAll, reject };
